export { default } from './Minus';
